import { createAction, props } from '@ngrx/store';
import { ResponseCheckToken, RequestCheckToken } from '../../shared/interfaces';
import { CheckTokenTypes } from '../../shared/enums';


export const getCheckToken = createAction(
    CheckTokenTypes.CHECK_TOKEN,
    props<{ request: RequestCheckToken}>()
);

export const getCheckTokenSuccess = createAction(
    CheckTokenTypes.CHECK_TOKEN_SUCCESS,
    props<{ response: ResponseCheckToken }>()
);

export const getCheckTokenError = createAction(
    CheckTokenTypes.CHECK_TOKEN_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    CheckTokenTypes.CLEAN_STATE
);
